module.exports = (__webpack_require__(6))(445);


//////////////////
// WEBPACK FOOTER
// delegated ./node_modules/react-is/index.js from dll-reference vendor_aa0bb54e7e791c5951ff
// module id = 198
// module chunks = 0 1 2 3 4 5 7